export const getEstimateWidth = (options: string[], ratio: number): number => {
    let maxLength = 0
    for (let o of options) {
    if (o.length > maxLength)
        maxLength = o.length
    }
    return maxLength * ratio + 48 // 48 = width of the dropdown icon
}